import { isEmpty } from 'lodash';

export default function isLoadingCombinedPipeline({ integrationLoading, pipelineLoading, error, deployedPipeline }) {
  const networkLoading = integrationLoading || pipelineLoading;
  const dataIsReady = error || !isEmpty(deployedPipeline);

  return Boolean(networkLoading || !dataIsReady);
}
